// extracted by mini-css-extract-plugin
export var box = "_51-2";
export var checkboxControl = "_51-0";
export var checkboxRow = "_51-9";
export var checked = "_51-3";
export var descriptionSpacer = "_51-b";
export var disabled = "_51-4";
export var icon = "_51-7";
export var input = "_51-1";
export var labelSpacer = "_51-a";
export var medium = "_51-6";
export var small = "_51-5";
export var text = "_51-8";